export default "__VITE_ASSET__CXXTSo0M__"